/*
    Abstract class for additional validation of DESS schedule rows
*/
export default class ScheduleValidator {
    hasError = false;
    errorMessage = '';
    valueField;

    constructor(valueField) {
        this.valueField = valueField;
    }

    // eslint-disable-next-line no-unused-vars
    validateRows(rows) {
        throw new Error('Abstract method');
    }

    hasError() {
        return this.hasError;
    }

    getErrorMessage() {
        return this.errorMessage;
    }

    clearErrors() {
        this.hasError = false;
        this.errorMessage = '';
        this.errorFields = [];
    }
}
